import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import type { SvgIconComponent } from "@mui/icons-material";

export interface ExistenceIndicatorResult {
    tooltip: string;
    color: string;
    Icon: SvgIconComponent;
}

export function getExistenceIndicator(
    existsInCS?: boolean,
    existsInD365?: boolean,
): ExistenceIndicatorResult | null {
    if (existsInCS === undefined || existsInD365 === undefined) {
        return null;
    }
    if (existsInCS && existsInD365) {
        return { tooltip: "Exists in D365", color: "success.main", Icon: CheckCircleIcon };
    }
    if (existsInCS && !existsInD365) {
        return { tooltip: "Not in D365", color: "error.main", Icon: CancelIcon };
    }
    if (!existsInCS && existsInD365) {
        return { tooltip: "Not in CS", color: "warning.main", Icon: CancelIcon };
    }
    return null;
}
